import { useEffect, useState } from "react";
import { faRobot, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Preloader from "../preloader";
import { useSelector } from "react-redux";
import {
  ErrorToastContainer,
  SuccessToastContainer,
  WorningToastContainer
} from "../../function/CustomFunction";
import domain from "../../../reusecomponent/domain";

function AutoResponderSettings() {

  const [loader, setLoader] = useState(false);
  const service = useSelector((state) => state?.serviceStore?.value);
  const Accesstoken = useSelector((state) => state?.Token?.value);
  const [settings, setSettings] = useState({
    greetingEnabled: service.auto_responder === 1 ? true : false,
    greetingMessage: "",
    greetingSchedule: "always",
    greetingStartTime: "09:00",
    greetingEndTime: "18:00",
    greetingRecipients: "new",
  });


  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= TOGGLE ENABLE ================= */
  const handleToggle = () => {
    if (service?.auto_responder === 0) {
      WorningToastContainer("Upgrade to unlock this feature");
      return;
    }

    setSettings((prev) => ({
      ...prev,
      greetingEnabled: !prev.greetingEnabled,
    }));
  };

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    datafetch();
  }, []);

  useEffect(()=>{
    console.log(settings);
  },[settings]);

  const datafetch = async () => {
    try {
      setLoader(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${Accesstoken}`);

      const response = await fetch(`${domain()}/autoresponder`, {
        method: "GET",
        headers: myHeaders,
      });

      const result = await response.json();

      if (response.ok && result?.status && result?.data != null) {
        const finaldata = JSON.parse(result?.data?.auto_responder_settings);
        setSettings({
          greetingEnabled: service.auto_responder === 1 ? finaldata.greetingEnabled : false,
          greetingMessage: finaldata.greetingMessage ?? "",
          greetingSchedule: finaldata.greetingSchedule ?? "always",
          greetingStartTime: finaldata.greetingStartTime ?? "09:00",
          greetingEndTime: finaldata.greetingEndTime ?? "18:00",
          greetingRecipients: finaldata.greetingRecipients ?? "new",
        });
        
      } else if(response.ok && !result?.status){
        ErrorToastContainer(result.message || "Failed to load settings");
      }
    } catch (error) {
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoader(false);
    }
  };
  

  const setResponder = async () => {
        if (service?.auto_responder === 0) {
          WorningToastContainer("Upgrade to unlock this feature");
          return;
        }

        try {
          setLoader(true);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", `Bearer ${Accesstoken}`);
          myHeaders.append("Content-Type", "application/json");

          const response = await fetch(`${domain()}/autoresponder`, {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(settings),
          });

          const result = await response.json();

          if (response.ok && result?.status) {
            SuccessToastContainer(result.message);
          } else {
            ErrorToastContainer(result.message || "Failed to load settings");
          }
        } catch (error) {
          ErrorToastContainer("Internal Server Problem");
        } finally {
          setLoader(false);
        }
  }

  /* ================= UI ================= */
  return (
    <div className="container-fluid dashboard-main pt-0">
      <Preloader action={loader} />

      <div className="card shadow-sm">
        <div className="card-body">

          <h4 className="mb-4">
            <FontAwesomeIcon icon={faRobot} className="me-2 text-primary" />
            AutoResponder Settings
          </h4>

          {/* GREETING MESSAGE */}
          <div className="card mb-4 border">
            <div className="card-body">

              <h6 className="mb-3">👋 Greeting Message</h6>

              {/* Toggle */}
              <div className="form-check form-switch mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={settings.greetingEnabled}
                  onChange={handleToggle}
                />
                <label className="form-check-label">
                  Enable Greeting
                </label>
              </div>

              <fieldset disabled={!settings.greetingEnabled}>

                {/* Message */}
                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-control"
                    rows="6"
                    name="greetingMessage"
                    value={settings.greetingMessage}
                    onChange={handleChange}
                  />
                </div>

                {/* Schedule */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Schedule</label>

                  <div className="form-check">
                    <input
                      type="radio"
                      name="greetingSchedule"
                      value="always"
                      checked={settings.greetingSchedule === "always"}
                      onChange={handleChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label">Always Send</label>
                  </div>

                  <div className="form-check">
                    <input
                      type="radio"
                      name="greetingSchedule"
                      value="custom"
                      checked={settings.greetingSchedule === "custom"}
                      onChange={handleChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label">Custom Schedule</label>
                  </div>
                </div>

                {/* Custom Time */}
                {settings.greetingSchedule === "custom" && (
                  <div className="row mb-3">
                    <div className="col">
                      <label>Start Time</label>
                      <input
                        type="time"
                        name="greetingStartTime"
                        className="form-control"
                        value={settings.greetingStartTime}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col">
                      <label>End Time</label>
                      <input
                        type="time"
                        name="greetingEndTime"
                        className="form-control"
                        value={settings.greetingEndTime}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}

                {/* Recipients */}
                <div>
                  <label className="form-label fw-semibold">Recipients</label>
                  <select
                    className="form-select"
                    name="greetingRecipients"
                    value={settings.greetingRecipients}
                    onChange={handleChange}
                  >
                    <option value="new">New Customers Only</option>
                    <option value="all">All Customers</option>
                  </select>
                </div>

              </fieldset>
            </div>
          </div>

          {/* SAVE */}
          <div className="text-end">
            <button
              className="btn btn-primary"
              onClick={setResponder}
              disabled={service?.auto_responder === 0}
            >
              <FontAwesomeIcon icon={faSave} className="me-2" />
              Save Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AutoResponderSettings;